import { useState } from "react";
import { homeService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { IApiRequest, IBidResponse } from "@miplatform/types";

export const useBids = () => {
  const [bids, setBids] = useState<IBidResponse[]>([]);
  const [bidDetails, setBidDetails] = useState<IBidResponse | null>(null);
  const [refresh, setRefresh] = useState(false);

  const stateManager = useComponentState();

  const getBids = ({ top, skip, filters, sort = "name" }: IApiRequest = {}) => {
    return stateManager.run(async () => {
      const response = await homeService.plans.getAll({
        filters,
        sort,
        top,
        skip,
      });
      if (response.status === HTTP_STATUSES.OK) {
        setBids(response.data);
      }
      return response;
    });
  };

  const getBidDetails = (id: string) => {
    return stateManager.run(async () => {
      const response = await homeService.plans.getById({ id });
      if (response.status === HTTP_STATUSES.OK) {
        setBidDetails(response.data);
      }
      return response;
    });
  };

  const updateBid = async (data: IBidResponse) => {
    return stateManager.run(async () => {
      return homeService.plans.update({
        data,
        toastMessageConfig: {
          success: {
            text: `${data.name} was updated successfully.`,
          },
        },
      });
    });
  };

  const deleteBid = async (data: IBidResponse) => {
    stateManager.run(async () => {
      const response = await homeService.plans.delete({
        data,
        toastMessageConfig: {
          success: {
            text: `${data.name} was deleted successfully.`,
          },
        },
      });
      if (response.status === HTTP_STATUSES.OK) {
        setRefresh((prev) => !prev);
      }
    });
  };

  const createAreaTemplate = async (data: Partial<IBidResponse>) => {
    return stateManager.run(async () => {
      return homeService.plans.templates.createAreaTemplate({
        data,
        toastMessageConfig: {
          success: {
            text: `Successfully created Area Template ${data.name}.`,
          },
        },
      });
    });
  };

  return {
    isLoading: stateManager.isBusy(),
    refresh,
    bids,
    setBids,
    getBids,
    bidDetails,
    setBidDetails,
    getBidDetails,
    updateBid,
    deleteBid,
    createAreaTemplate,
  };
};
